import Vue from 'vue'
import { buttonPremiss } from './index'

Vue.prototype.isPrimaryKey = buttonPremiss
